import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=e713d99c&scoped=true"
import script from "./RegistrationForm.vue?vue&type=script&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=e713d99c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e713d99c",
  null
  
)

export default component.exports